import { useEffect, useState } from "react";
import { TagDTO, TagsDTO, TagType } from "../../DTO/TagDTO";

enum Status {
  loading,
  done,
}
export function ListTagFilter(props: {
  kind: TagType,
  update: (tagIds: number[]) => Promise <void>,
  title: string,
  single: boolean,
  selected: number[],
}) {
  const [title, setTitle] = useState(props.title)
  const [tags, setTags] = useState(new TagsDTO({kind: props.kind}))
  const [status, setStatus] = useState(Status.loading)
  const [selected, setSelected] = useState<number[]>(props.selected)
  function isSelected(tag: TagDTO): boolean {
    return selected.includes(tag.id)
  }
  function selectTag(tag: TagDTO) {
    let newSelected: number[] = []
    if (props.single) {
      if (selected.includes(tag.id)) {
        newSelected =[]
      } else {
        newSelected = [tag.id]
      }
    } else {
      if (selected.includes(tag.id)) {
        newSelected = selected.filter(t => t !== tag.id)
      } else {
        newSelected = [...selected, tag.id]
      }
    }
    setSelected(newSelected)
    props.update(newSelected).then(() => {
      console.log('update done')
    })
  }
  useEffect(() => {
    console.log('useEffect ListTagFilter')
    tags.getFromServerByKind(props.kind, true).then(() => {
      console.log('useEffect done ListTagFilter', tags)
      setStatus(Status.done)
    })
  }, [props.kind, tags])
  /*
  useEffect(() => {
    setSelected(props.selected)
  }, [props.selected])
  */
  // return null
  return <div className={`w3-dropdown-hover ${selected.length > 0 ? 'w3-blue' : ''}`}>
    <button className={`w3-button`}>{title}</button>
    <div className={`w3-dropdown-content w3-bar-block w3-border`}>
      {
        tags.getTags().map(t => <button
          key={`tag-filter-item-${t.id}`}
          className={`w3-bar-item w3-button ${isSelected(t) ? 'w3-blue' : ''}`} onClick={() => {
          selectTag(t)
        }}>{t.name}</button>)
      }
    </div>
  </div> 
}
